import {SprintsRepository} from '../persistence/sprints_repository';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, filter, map, shareReplay, startWith, switchMap} from 'rxjs/operators';
import {Sprint} from '../models/sprint';

export enum HighlightState {
    Idle,
    Highlighted,
    Background,
}

export class SprintHighlighter {
    private triggeredSprint = new BehaviorSubject<number | null>(null);

    private highlightedSprints: Observable<Sprint[]> = this.triggeredSprint.pipe(
        switchMap((sprintId) => {
            if (sprintId === null) {
                return of([]);
            }

            return of(sprintId).pipe(
                map((sprintId) => this.sprintRepository.find(sprintId)),
                filter((sprint): sprint is Sprint => sprint !== null),
                map((sprint) => this.sprintRepository.findByMoneybirdContactId(sprint.estimate.moneybird_contact_id)),
            );
        }),
        distinctUntilChanged(),
        shareReplay(1),
    );

    constructor(private sprintRepository: SprintsRepository) {}

    public isHighlighted(sprintId: number): Observable<HighlightState> {
        return this.highlightedSprints.pipe(
            map((sprints) => {
                if (sprints.length === 0) {
                    return HighlightState.Idle;
                }
                return sprints.some((sprint) => sprint.id === sprintId)
                    ? HighlightState.Highlighted
                    : HighlightState.Background;
            }),
        );
    }

    public register(sprintId: number) {
        this.triggeredSprint.next(sprintId);
    }

    public clear(sprintId: number) {
        if (this.triggeredSprint.value === sprintId) {
            this.triggeredSprint.next(null);
        }
    }
}
